import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

if (window.loadDevTools) {
  Vue.config.devtools = true;
  Vue.config.debug = true;
}

export { Vue };
export { Vuex };
export { VueRouter };




// WEBPACK FOOTER //
// ./src/vue-loader.js